import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-small",
  "use": "close-small-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"close-small\"><path d=\"M.189.349a.9.9 0 0 0 .075 1.188L3.726 5 .264 8.463l-.088.104c-.262.391-.216.865.088 1.17l.104.087.1.059a.9.9 0 0 0 1.07-.147L5 6.273l3.463 3.463a.9.9 0 0 0 1.273 0l.075-.085a.9.9 0 0 0-.075-1.188L6.273 5l3.463-3.463.088-.104c.262-.391.216-.865-.088-1.17L9.651.19a.9.9 0 0 0-1.188.075L5 3.726 1.537.264a.9.9 0 0 0-1.273 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol